import React from 'react'

export const ModalButtons = props => (
  <div className={props.classes.container}>{props.children}</div>
)
